export default "__VITE_ASSET__5c1e8453__"